<style>
.nav-side-menu {

  overflow: auto;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0;
  width: 270px;
  height: 100%;
  color: #e1ffff;
}
/* .nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
} */
.nav-side-menu .toggle-btn {
  display: none;
}
.nav-side-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 35px;
  cursor: pointer;
}
.nav-side-menu ul .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0;
}
.nav-side-menu ul .sub-menu li:hover {
  background-color: #020203;
  transition: none;
}
.nav-side-menu li {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 35px;
  cursor: pointer;
  padding-left: 0;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
  transition: all 0.2s ease;
}
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0;
}
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  margin: 10px 15px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  transition: none;
}
.sub-menu li {
  padding-left: 20px;
}
li .fa-chevron-down {
  margin: 10px;
  vertical-align: middle;
  float: right;
  transition: transform 0.4s;
}
li.active .fa-chevron-down {
  transform: rotateX(180deg);
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #fff;
    color: #000;
    width: 40px;
    text-align: center;
    border-radius: 4px;
  }
  /* .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  } */
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
    width: 270px;
  }
}
@media (min-width: 767px) {
  .workspace-content {
    margin-left: 270px;
  }
}
.workspace-content {
  padding: 20px;
  max-width: 80%;
}
.back-btn {
  color: whitesmoke;
  font-size: 24px;
}
.back-btn:hover {
  color: white;
}

</style>
<template>
    <div>
        <div class="row">
            <div class="col-md-2">
                <nav class="nav-side-menu">
                  <div>
                    <a :href="'/'" class="btn back-btn float-right"><i class="fa fa-arrow-left"></i></a>
                  </div>
                    <div class="brand m-2">
                          <select v-model="workspace" class="form-control">
                            <option value="">Select Workspace</option>
                            <option v-for="(workspace, index) in workspaces" :key="workspace.id" :value="workspace.id">{{ workspace.title }}</option>
                          </select>
                    </div>
                    <div class="m-2" v-if="showFilter">
                      <p class="mb-0">Filter</p>
                        <select v-model="filter" class="form-control">
                          <option value="">Select</option>
                          <option value="company_name">By Company Name</option>
                          <option value="company_created_date">By Company Created Date</option>
                          <option value="job_expiry">By Job Expiry</option>
                        </select>
                        <div class="m-2 d-inline-flex">
                          <button @click.prevent="filterJobsByEXpiry()" type="button" class="btn btn-primary">View By Jobs Expiry</button>
                          <button @click.prevent="filterReset()" type="button" class="btn btn-danger ml-2">Reset</button>
                        </div>

                        <!-- <a href="" @click.prevent="filterReset()" class="float-right mt-0 text-white">Reset</a> -->
                    </div>
                  <div class="">
                      <app-icon name="briefcase"/>
                    <a href="#openAllJobTasks" @click="openAllJobTasks" class="text-white">Upcoming Tasks
                    </a>
                  </div>
                    <i class="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i>
                    <div class="menu-list">
                        <ul id="menu-content" class="menu-content collapse out" v-if="companyJobs">                            
                            <app-overlay-loader v-if="preloader" />
                            <li v-for="(workspace_company, index) in workspace_companies" :key="workspace_companies.id">
                                <a href="javascript:void(0)">
                                  <i class="fa fa-fw fa-folder fa-lg"></i> 
                                  <span @click.prevent="viewProfile(workspace_company)">{{ workspace_company.company ? workspace_company.company.company_name : '---' }} </span>
                                  <span v-if="workspace_company.company.jobs.length > 0" data-toggle="collapse" :data-target="'#new'+index" class="collapsed" data-parent="#menu-content">
                                    <i class="fa fa-chevron-down"></i>
                                  </span>
                                </a>
                            <ul class="sub-menu collapse" :id="'new'+index">
                                <li v-for="(job, index) in workspace_company.company.jobs" :key="job.id">
                                  <a href="" @click.prevent="viewDetail(workspace_company.company_id, job)">{{ job.title }}</a>
                                </li>
                            </ul>
                          </li>

                        </ul>
                        <ul class="sub-menu" v-if="filterJobs">
                            <app-overlay-loader v-if="preloader" />
                            <li v-for="(job, index) in workspace_jobs" :key="job.id">
                              <a href="" @click.prevent="viewDetail(job.company_id, job)">{{ job.title }}</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
          <div class="col-md-10 workspace-content">
              <workspace-main-content v-if="isMainContent" :companyId="workspace_company_id" :jobId="job_id" :key="componentKey"></workspace-main-content>
              <my-profile v-if="isProfileShow" :id="user_id" :remove="true" :key="componentKey"></my-profile>
              <workspace-jobs-tasks v-if="showAllJobTasks"></workspace-jobs-tasks>
          </div>


        </div>
    </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import {
    WORKSPACE_LIST,WORKSPACE_JOB_LIST,WORKSPACE_COMPANY_LIST
} from "../../../../Config/ApiUrl";
import AppLibrary from "../../../../Helpers/AppLibrary";
import { axiosGet } from "../../../../Helpers/AxiosHelper";

export default {
  name: "Workspace",
  extends: AppLibrary,
  mixins: [FormMixin],
  data() {
    return {
      showAllJobTasks: false,
      showFilter: false,
      preloader: false,
      isMainContent: false,
      isProfileShow: false,
      workspaces: [],
      workspace: '',
      workspace_companies: [],
      workspace_jobs: [],
      workspace_company_id: '',
      job_id: '',
      user_id: '',
      componentKey: 0,
      filter: '',
      companyJobs: false,
      filterJobs:false,
    };
  },
  methods: {
    openAllJobTasks(){
      this.isMainContent = false;
      this.isProfileShow = false;
      return this.showAllJobTasks = !this.showAllJobTasks
      },
    getUsers() {
      axiosGet(WORKSPACE_LIST)
          .then((res) => {
            this.workspaces = res.data.list;
          })
          .catch((error) => {

          });
    },
    workspaceJobs(type = null) {
      if (this.workspace) {
          this.preloader = true;
          let filter = '';
          if (this.filter) {
              filter = '?filter='+this.filter;
          }
          if (type) {
            filter = '?filter='+type;
          }
          axiosGet(WORKSPACE_COMPANY_LIST+this.workspace+filter)
          .then((res) => {
            if(!type) {
              this.workspace_companies = res.data.list;
              this.filterJobs = false;
              this.companyJobs = true;
              this.workspace_jobs = [];
            }
            else {
              this.workspace_jobs = res.data.list;
              this.companyJobs = false;
              this.filterJobs = true;
              this.workspace_companies = [];
              console.log(this.workspace_jobs);
            }

            if (this.workspace_companies.length > 0 || this.workspace_jobs.length > 0) {
              this.showFilter = true;
            }
            else {
              this.showFilter = false;
            }

            this.preloader = false;

              // console.log(res.data.list);
          })
          .catch((error) => {

          });
      }
      else {
          this.workspace_companies = [];
          this.filter = '';
          this.isMainContent = false;
      }
    },
    filterJobsByEXpiry() {
      this.filter = '';
      this.workspaceJobs('jobsFilter');
    },
    viewDetail(company_id, data) {
      this.showAllJobTasks = false;

      this.workspace_company_id = company_id;
        this.job_id = data.id;
        this.componentKey += 1;
        this.isProfileShow = false;
        this.isMainContent = true;
      this.$store.commit('updateSharedData', {index: "selectedCompany", newValue: company_id})
      this.$store.commit('updateSharedData', {index: "selectedData", newValue: data})
    },
    viewProfile(data) {
      this.user_id = data.company.user.id;
      this.componentKey += 1;
      this.isMainContent = false;
      this.showAllJobTasks = false;
      this.isProfileShow = true;
    },
    filterReset() {
      this.filter = '';
      this.workspaceJobs();
    }
  },
  mounted() {
    this.getUsers();
  },
  watch: {
    workspace() {
      this.workspaceJobs();
    },
    filter() {
      this.workspaceJobs();
    },
  }
};
</script>